export const download = (link: string) => {
  window.open(link);
};
